<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height"
        >
            <v-col class="fill-height of-y" cols="3">
                <multi-select-list
                        :items="sortedStatuses"
                        itemKey="id"
                        :showCheckBoxes="true"
                        :multiple="false"
                        headlineKey="name"
                        v-model="selectedStatusId"
                        filterLabel="Filter Statuses"
                >
                    <div slot="header" class="px-2 pt-2">
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="createStatusShow = !createStatusShow"
                        >
                            <v-icon left>mdi-plus</v-icon>
                            Add Employee Status
                        </v-btn>
                    </div>
                </multi-select-list>
            </v-col>
            <divider color="primary darken-1" :vertical="true"/>
            <v-col class="fill-height of-y pa-2" cols="4" v-if="!!selectedStatus">
                <v-card>
                    <ModifyStatus :edit-status="selectedStatus" @save="upsertStatus($event)"/>
                </v-card>
            </v-col>
            <v-dialog
                    v-if="createStatusShow && createStatusObj"
                    v-model="createStatusShow"
                    :width="400"
                    persistent
            >
                <v-card>
                    <ModifyStatus :edit-status="createStatusObj" @dismiss="createStatusShow = !createStatusShow" @save="upsertStatus($event)"/>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyStatus from "./ModifyStatus.vue";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";
import {EmpStatus} from "@/core/store";

export default {
    components: {Divider, ModifyStatus, MultiSelectList},
    props: {},
    data() {
        return {
            selectedStatusId: null,
            createStatusObj: new EmpStatus({}),
            createStatusShow: false,
        }
    },
    watch: {
        createStatusShow(val) {
            if (val)
                this.createStatusObj = new EmpStatus({})
        }
    },
    methods: {
        async upsertStatus(event) {
            let {empStatus, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/status`, empStatus)
                const addedStatusID = (await waitForEvent(eventID)).empStatuses.pop().id
                this.createStatusShow = false
                this.selectedStatusId = addedStatusID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }

    },
    computed: {
        ...mapGetters(['empStatuses', 'empStatusesRef']),
        sortedStatuses() {
            return [...this.empStatuses].sort((a,b) => a.name > b.name ? 1 : -1)
        },
        selectedStatus() {
            if (!this.selectedStatusId)
                return null
            console.log(this.empStatuses, this.selectedStatusId, this.empStatuses.find(obj => obj.id === this.selectedStatusId))
            return this.empStatuses.find(obj => obj.id === this.selectedStatusId)
        }
    },
}
</script>

<style scoped>

</style>